import { useState } from 'react';
import { detectCriteria } from '../constants';
import { placeBetAPI } from '../api/bets';

export function useBetting({ user, showAuth, refreshUser, bal, setBal, showToast }) {
  const [modal, setModal] = useState(null);
  const [betAmt, setBetAmt] = useState("");
  const [myBets, setMyBets] = useState([]);

  const openBet = (b, side) => { setModal({ b, entity: b.entity, side }); setBetAmt(""); };

  function getAllBets(sourceMarkets, authorMarkets) {
    const bets = [];
    const process = (markets, type) => {
      (markets || []).forEach(entity => {
        (entity.criteria || []).forEach(bet => {
          const crit = bet.criteria ? bet.criteria.toLowerCase() : detectCriteria(bet.q);
          bets.push({
            id: bet.id, entity: type === 'source' ? (entity.outlet || entity.name) : entity.name,
            entityB: bet.entityNameB || null, type,
            avg30: entity.trailing30dAvg || entity.avgScore || 70,
            cnt: entity.scoredArticles || entity.articleCount || 0,
            q: bet.q, criteria: crit,
            questionType: bet.questionType || 'main_line',
            cad: bet.cadence || "weekly",
            yV: bet.yV || 500, nV: bet.nV || 500,
            yO: bet.yO || 1.5, nO: bet.nO || 1.5,
            trend: entity.trend || "stable",
            yesPct: bet.yesPct || 50,
            noPct: bet.noPct || 50,
          });
        });
      });
    };
    process(sourceMarkets, "source");
    process(authorMarkets, "author");
    const seen = new Set();
    return bets.filter(b => {
      if (seen.has(b.id)) return false;
      seen.add(b.id);
      return true;
    });
  }

  function grp(bets) {
    const g = {};
    for (const b of bets) {
      if (!g[b.entity]) g[b.entity] = { name: b.entity, type: b.type, avg30: b.avg30, cnt: b.cnt, bets: [], trend: b.trend, vol: 0 };
      g[b.entity].bets.push(b);
      g[b.entity].vol += b.yV + b.nV;
      if (b.trend) g[b.entity].trend = b.trend;
    }
    return Object.values(g).sort((a, b) => b.vol - a.vol);
  }

  const placeBet = () => {
    if (!user) {
      showAuth();
      return;
    }

    const a = parseFloat(betAmt);
    if (!a || a <= 0 || a > bal) return;
    const k = modal.b.yV * modal.b.nV;
    let shares;
    if (modal.side === "yes") { const nn = modal.b.nV + a; shares = modal.b.yV - (k / nn); }
    else { const ny = modal.b.yV + a; shares = modal.b.nV - (k / ny); }

    placeBetAPI(user.id, modal.b.id, modal.side === "yes" ? "yes" : "no", a)
    .then(r => r.json()).then(data => {
      if (data.error) { showToast(data.error, "error"); return; }
      setMyBets(p => [{ id: `b${Date.now()}`, question: modal.b.q, entity_name: modal.entity, side: modal.side === "yes" ? "YES" : "NO", amount: a, shares, potential_payout: shares, status: "active", cadence: modal.b.cad, criteria: modal.b.criteria }, ...p]);
      setBal(p => p - a);
      refreshUser();
      showToast(`${modal.side.toUpperCase()} locked! ${shares.toFixed(2)} shares`);
      setModal(null); setBetAmt("");
    }).catch(() => {
      setMyBets(p => [{ id: `b${Date.now()}`, question: modal.b.q, entity_name: modal.entity, side: modal.side === "yes" ? "YES" : "NO", amount: a, shares, potential_payout: shares, status: "active", cadence: modal.b.cad, criteria: modal.b.criteria }, ...p]);
      setBal(p => p - a);
      showToast(`${modal.side.toUpperCase()} locked! ${shares.toFixed(2)} shares`);
      setModal(null); setBetAmt("");
    });
  };

  return { modal, setModal, betAmt, setBetAmt, myBets, openBet, placeBet, getAllBets, grp };
}
